import { Button, Typography } from '@mui/material'
import React, { type FunctionComponent } from 'react'
import { Link } from 'react-router'
import { type ActiveIntegration as ActiveIntegrationType, INACTIVE_INTEGRATION_STATUS } from '../../types'

import { formatDate, trackAnalyticEvent, ANALYTICS_LOCATIONS, nextUpdateDisplayLabel, nextUpdateDisplayValue, noWrapTime } from '../../utils'
import { ActiveCard, ActiveCardContent, ActiveCardContentInnerWrapper, ActiveCardDetails, ActiveCardHeader, ActiveCardName, ActiveCardTitle, IntegrationImage } from './active-integration.styles'
import { StatusChip } from './'

type ActiveIntegrationProps = {
    activeIntegration: ActiveIntegrationType,
	isShowingDates?: boolean,
}

export const ActiveIntegration: FunctionComponent<ActiveIntegrationProps> = ( { activeIntegration, isShowingDates = true } ) => {
	const { feedId, lastUpdate, name, isActive, integration, nextUpdate, currentStatus } = activeIntegration
	const integrationName = integration?.name ?? '-'
	const integrationLogoUrl = integration?.oemLogoUrl ?? undefined
	const lastUpdateText = lastUpdate ? formatDate( lastUpdate, '-' ) : '-'
	const nextUpdateText = nextUpdateDisplayValue( currentStatus, nextUpdate, integration?.refreshIntervalMinutes )

	return (
		<ActiveCard>
			<ActiveCardHeader
				avatar={<IntegrationImage src={integrationLogoUrl} alt={integrationName} />}
				title={<ActiveCardTitle variant={'h2'} component={'h4'}>{integrationName}</ActiveCardTitle>}
				subheader={<ActiveCardName variant="body2">{name}</ActiveCardName>}
			/>
			<ActiveCardContent>
				<hr />
				<ActiveCardContentInnerWrapper>
					{currentStatus !== null && currentStatus !== undefined && <StatusChip status={isActive ? currentStatus : INACTIVE_INTEGRATION_STATUS} />}
					<ActiveCardDetails>
						{ isShowingDates &&
							<>
								<li>
									<Typography><strong>Last Update:</strong> {noWrapTime( lastUpdateText )}</Typography>
								</li>
								<li>
									<Typography><strong>{nextUpdateDisplayLabel( currentStatus )}</strong> {noWrapTime( nextUpdateText )}</Typography>
								</li>
							</>
						}
					</ActiveCardDetails>
					<Link
						to={`/manage/${feedId}`}
						onClick={() => {
							trackAnalyticEvent(
								ANALYTICS_LOCATIONS.ACTIVE_INTEGRATIONS,
								'click',
								'Manage Integration',
								{ integration: `${name} (${feedId})` },
							)
						}}
					>
						<Button variant="outlined">Manage</Button>
					</Link>
				</ActiveCardContentInnerWrapper>
			</ActiveCardContent>
		</ActiveCard>
	)
}
